import Model from './Model'
import { toFormData } from '@utils'

export default class VehicleLog extends Model
{
    static get SupportedTypes() {
        return ['Oil Service', 'Full Service', 'MOT']
    }

    getFormAttributes () {
        const attributes = this.except([])
        attributes.carried_out_by = {
            label: attributes.carried_out_by,
            value: attributes.carried_out_by_id
        }

        if (! VehicleLog.SupportedTypes.includes(attributes.type)) {
            attributes.type_other = attributes.type
            attributes.type = 'Other'
        }

        return attributes
    }

    static parseAttributes(attributes = {}) {
        if(attributes.carried_out_by?.value){
            attributes.carried_type = attributes.carried_out_by?.value.split('_')[0];
            attributes.carried_id = attributes.carried_out_by?.value.split('_')[1];
        }else{
            attributes.carried_id = null;
            attributes.carried_type = null;
        }
        return attributes
    }

    static async create (vehicleId, attributes) {
        attributes = this.parseAttributes(attributes);
        const url = route('api.v1.vehicles.logs.store', vehicleId)
        const { data } = await Http.post(url, toFormData(attributes))
        return this.make(data)
    }

    async update (vehicleId, attributes = {}) {
        const url = route('api.v1.vehicles.logs.store', vehicleId)
        const payload = { ...attributes, id: this.id }
        const { data } = await Http.post(url, toFormData(this.constructor.parseAttributes(payload)))
        return this.fill(data)
    }
}
